import { Component } from 'react'
import { ILayoutManagerState, LayoutManagerRenderFunctionType } from './types'

interface LayoutHostProps<T extends string> {
	renderFn: LayoutManagerRenderFunctionType<T>
}

export default class LayoutHost<T extends string = string> extends Component<
	LayoutHostProps<T>,
	Partial<ILayoutManagerState<T>>
> {
	state: Partial<ILayoutManagerState<T>> = {}

	render() {
		const { contentKey, type, children, systemMessage } = this.state
		return contentKey !== undefined && type !== undefined
			? this.props.renderFn(contentKey, type, children, systemMessage)
			: null
	}
}
